import { Col, Input, Label, Row } from 'reactstrap';
import { AvField } from 'availity-reactstrap-validation';

import FieldInfo from '../../field-info';
import SettingsField from '../../settings-field';

const IncomingPasswordFields = ({
    t,
    isFetching,
    incomingSameAsSmtp,
    incomingSecretRequired,
    hasSavedIncomingSecret,
    onIncomingSameAsSmtpChange,
}) => (
    <>
        <div className="form-check mb-3">
            <Input
                type="checkbox"
                className="form-check-input"
                id="incomingSameAsSmtp"
                checked={incomingSameAsSmtp}
                onChange={(e) => onIncomingSameAsSmtpChange(e.target.checked)}
            />
            <Label check for="incomingSameAsSmtp" className="form-check-label">
                {t('IMAP password is the same as SMTP password')}
            </Label>
            <FieldInfo id="info-incoming-same">
                {t('Uncheck this only if the incoming mailbox uses a different password or app password.')}
            </FieldInfo>
        </div>

        {!incomingSameAsSmtp && (
            <Row>
                <Col sm="12" md="6" className="mb-3">
                    <SettingsField
                        id="incomingSecret"
                        label={t('IMAP password')}
                        required={incomingSecretRequired}
                        isFetching={isFetching}
                        hint={hasSavedIncomingSecret
                            ? t('Password saved. Enter a new password only to replace it.')
                            : undefined}
                    >
                        <AvField
                            id="incomingSecret"
                            name="incomingSecret"
                            type="password"
                            autoComplete="new-password"
                            placeholder={hasSavedIncomingSecret ? '••••••••••••' : ''}
                            className="form-control"
                            validate={{
                                required: {
                                    value: incomingSecretRequired,
                                    errorMessage: t('This field cannot be blank'),
                                },
                            }}
                        />
                    </SettingsField>
                </Col>
            </Row>
        )}
    </>
);

export default IncomingPasswordFields;
